import type { CurrentRead } from '@signalvote/data';
import { AlertCircle } from 'lucide-react';

/** A calendar drawn without its shifts, events or key dates looks like a calendar with none, so the gap is named. */
export function CalendarShiftsNotice({
  read,
  subject = 'shifts',
}: {
  read: CurrentRead<unknown>;
  subject?: 'shifts' | 'calendar events' | 'key dates';
}) {
  if (read.status !== 'failed' && read.status !== 'offline') return null;
  return (
    <div role="alert" className="mx-2 my-1 flex items-center gap-2 rounded-md border border-destructive/30 bg-destructive/5 px-3 py-2 text-xs text-destructive">
      <AlertCircle className="h-3.5 w-3.5" aria-hidden />
      {read.status === 'offline'
        ? `You're offline, so ${subject} can't load. The calendar shows no ${subject} until you reconnect.`
        : `Couldn't load ${subject}. The calendar shows none until they load; try again shortly.`}
    </div>
  );
}
